enum events {
  MEMBERSHIPS_ADDED = "memberships-added"
}

export default events
